import { IPreorderCompleted } from 'my-poppies-b2b-types';

import { timestampMockHelpers } from '@/utils/timestampMockHelpers';

export const dummyDataPreordersCompleted: IPreorderCompleted[] = [
  {
    userRole: 'EVA',
    id: 'first-express-preorder',
    status: 'PREORDER_COMPLETED',
    type: 'EXPRESS',
    createdBy: 'EVA',
    createdAt: timestampMockHelpers.now,
    updatedBy: 'EVA',
    updatedAt: timestampMockHelpers.tenMinutesLater,
    positions: [
      { positionId: 'kleine-kapseln-40g', amount: 123 },
      { positionId: 'große-kapseln-120g', amount: 14 },
    ],
  },
  {
    userRole: 'EVA',
    id: 'second-express-order',
    status: 'PREORDER_COMPLETED',
    type: 'STANDARD',
    createdBy: 'EVA',
    createdAt: timestampMockHelpers.now,
    updatedBy: 'EVA',
    updatedAt: timestampMockHelpers.tenMinutesLater,
    positions: [
      { positionId: 'kleine-kapseln-40g', amount: 123 },
      { positionId: 'große-kapseln-120g', amount: 14 },
    ],
  },
];
